import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery} from '@yandex-delivery/utils'

import {fetch} from '../fetch'

export function fetchOrderAvailability(country?: string): Promise<{}> {
  return fetch({
    method: 'POST',
    url: addQuery(externalApiURL('cargo-corp/v1/client/order/availability'), {country}),
  })
}
